import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=6db37a26&scoped=true"
import script from "./PageBar.vue?vue&type=script&lang=js"
export * from "./PageBar.vue?vue&type=script&lang=js"
import style0 from "./PageBar.vue?vue&type=style&index=0&id=6db37a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db37a26",
  null
  
)

export default component.exports